import { Component, computed, input } from '@angular/core';
import { CHAR_LIMIT_FOR_SUGGESTIONS } from '@search/services';

import { SearchAutocompleteComponent } from '../search-autocomplete/search-autocomplete.component';
import { SearchMostSearchedComponent } from '../search-most-searched/search-most-searched.component';

@Component({
  selector: 'wl-search-popover',
  standalone: true,
  imports: [SearchMostSearchedComponent, SearchAutocompleteComponent],
  templateUrl: './search-popover.component.html',
  styleUrls: ['./search-popover.component.essent.scss'],
})
export class SearchPopoverComponent {
  readonly searchQuery = input.required<string>();
  readonly showMostSearched = computed(
    () =>
      !this.searchQuery() ||
      this.searchQuery().length < CHAR_LIMIT_FOR_SUGGESTIONS
  );
}
